import { makeStyles } from '@mui/styles';

export const useStylesTabs = makeStyles(theme => ({
  root: {
    marginBottom: 20,
    marginTop: 40,
    background: theme.colors.dark.darkSlateGray,
    justifyContent: 'center',
  },
  scroller: {
    flexGrow: '0',
  },
  indicator: {
    height: 3,
    borderRadius: '4px 4px 0px 0px',
    backgroundColor: theme.colors.orange.orange,
  },
  scrollButtons: {
    '& svg': {
      fill: theme.colors.orange.orange,
      fontSize: '2rem',
    },
  },
}));

export const useStylesTab = makeStyles(theme => ({
  root: {
    // '& .MuiTab-wrapper': {  // directly apply to root
    padding: '0 20px',
    fontSize: 16,
    fontWeight: 700,
    textAlign: 'center',
    textTransform: 'capitalize',
    color: theme.colors.light.freshPowder,
    // },
    '&.Mui-selected .MuiTab-wrapper': {
      color: theme.colors.orange.orange,
    },
  },
}));
